import type { Remittance } from '@api/models';
import { RemittanceQueryParams } from '@api/query';
import type { ComputedRef } from 'vue';

import { stuut } from '@/api';

import { computeEffectiveParams, useResourceNavigation } from './useResourceNavigation';
import type { UseResourceNavigationReturn } from './useResourceNavigation';

export interface UseRemittanceNavigationOptions {
  params?: ComputedRef<RemittanceQueryParams | null>;
}

export function useRemittanceNavigation(
  remittanceId: ComputedRef<string>,
  options: UseRemittanceNavigationOptions = {},
): UseResourceNavigationReturn {
  const effectiveParams = computeEffectiveParams<RemittanceQueryParams>(
    options.params,
    RemittanceQueryParams,
    {
      sortBy: 'created_at',
      sortOrder: 'desc',
    },
  );

  return useResourceNavigation<Remittance, RemittanceQueryParams>(remittanceId, {
    fetchList: (params) => stuut.remittances.list({ params }, true),
    detailRouteName: 'cash-app.remittances.remittance',
    params: effectiveParams,
    queryKeyPrefix: 'remittances',
    paramsClass: RemittanceQueryParams,
  });
}
